import { createFileRoute } from '@tanstack/react-router';

import { PerformancePage } from '@/features/parent/PerformancePage';

export const Route = createFileRoute('/_authed/parent/performance')({
  component: PerformancePage,
});
